module.exports = __webpack_public_path__ + "ipetbooking-landing/img/blob-2.904bb764.svg";